import React from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import Checkbox from "../../../../components/Checkbox";
import Icon from "../../../../components/Icon";
import Actions from "../../../../components/Actions";
import { useNavigate } from "react-router-dom";
import { getSessionGroupWithMembers } from "../../../../services/sessionGroup.service.js";


const Row = ({ item, value, onChange, onDelete, onDuplicate }) => {
    const navigate = useNavigate();

    const handleRowClick = async () => {
        try {
            // Récupérer les données complètes du groupe de session avec ses membres
            const sessionGroupData = await getSessionGroupWithMembers(item.id);
            navigate(`/admin/session-groups/${item.id}`, { state: { sessionGroup: sessionGroupData } });
        } catch (error) {
            console.error('Erreur lors de la récupération des données du groupe de session:', error);
            // Naviguer quand même avec les données partielles
            navigate(`/admin/session-groups/${item.id}`, { state: { sessionGroup: item } });
        }
    };

    const handleDelete = () => {
        if (onDelete) {
            onDelete(item.id);
        }
    };

    const handleDuplicate = () => {
        if (onDuplicate) {
            onDuplicate(item.id);
        }
    };

    const actions = [
        {
            title: "Modifier le groupe",
            icon: "edit",
            action: handleRowClick,
        },
        {
            title: "Dupliquer le groupe",
            icon: "copy",
            action: handleDuplicate,
        },
        {
            title: "Supprimer le groupe",
            icon: "trash",
            action: handleDelete,
        },
    ];

    return (
        <>
            <div className={styles.row} style={{ cursor: 'pointer' }}>
                <div className={styles.col}>
                    <Checkbox
                        className={styles.checkbox}
                        checked={value}
                        onChange={(e) => {
                            e.stopPropagation();
                            onChange(e);
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.item}>
                        <div className={styles.avatar}>
                            <img src={'/images/content/hour_logo.png'} alt="Logo" />
                        </div>
                        <div className={styles.details}>
                            <div className={styles.product}>{item.title}</div>
                        </div>
                    </div>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <span className={styles.memberCount}>{item.memberCount || 0} élève{(item.memberCount || 0) !== 1 ? 's' : ''}</span>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <span className={styles.createdDate}>{new Date(item.created).toLocaleDateString('fr-FR')}</span>
                </div>

                <div className={styles.col}>
                    <Actions 
                        className={styles.actions}
                        classActionsHead={styles.actionsHead}
                        classActionsBody={styles.actionsBody}
                        classActionsOption={styles.actionsOption}
                        items={actions}
                    />
                </div>

            </div>
        </>
    );
};

export default Row;
